/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';

import { AppUtilityService } from '../../../core/services/app-utility.service';
import { ConfigService } from '../../../core/services/config.service';
import { HistoryOps } from '../../../core/model/history-ops.model';
import { LmsModuleService } from '../../../core/services/lms-module.service';
import { LocoDetail } from '../../../core/model/loco-detail.model';
import { PopupService } from '../../../core/services/popup.service';
import { Tab } from '../../../core/model/tab.model';

@Component({
  selector: 'lms-loco-history-header',
  templateUrl: './loco-history-header.component.html',
  styleUrls: ['./loco-history-header.component.scss']
})
export class LocoHistoryHeaderComponent implements OnInit, OnChanges, OnDestroy {

  @Input() selectedTab: Tab;
  @Input() subTypes: any;
  @Input() historyOps: HistoryOps;
  locoSVG: LocoDetail;
  tabLevel: number;
  iconSubscription: any;
  lastRequestTime: number;
  iconIdentified: boolean;
  breakCall = false;

  @Output() historyTypeValueChange: EventEmitter<HistoryOps> = new EventEmitter<HistoryOps>();

  /**
   * Creates an instance of LocoHistoryHeaderComponent.
   * @param {LmsModuleService} lmsModuleService
   * @memberOf LocoHistoryHeaderComponent
   */
  constructor(private lmsModuleService: LmsModuleService, private configService: ConfigService,
    private popupService: PopupService, private appUtilityService: AppUtilityService) {
    this.tabLevel = this.configService.getConfigData().tabIndex.subTabs;
    this.historyOps = {};
    this.locoSVG = {};
  }

  /**
   * this is the life cycle method od this component
   * and called on initialization of this component
   * @memberOf LocoHistoryHeaderComponent
   */
  ngOnInit() {
  }

  /**
   * this is the life cycle method of this component
   * will be called when any changes occured in this
   * @memberOf LocoHistoryHeaderComponent
   */
  ngOnChanges() {
    if (this.selectedTab && this.selectedTab.tabSearchParameter) {
      this.processLocoIconInformation();
      if (!this.selectedTab.tabSearchParameter.spinnerVal) {
        this.selectedTab.tabSearchParameter.spinnerVal = 2;
        this.historyOps.days = this.selectedTab.tabSearchParameter.spinnerVal;
        this.lmsModuleService.updateSelectedTab(this.selectedTab);
      } else {
        this.historyOps.days = this.selectedTab.tabSearchParameter.spinnerVal;
      }
      if (!this.selectedTab.tabSearchParameter.displayType) {
        this.selectedTab.tabSearchParameter.displayType = ' ';
        this.historyOps.displayType = this.selectedTab.tabSearchParameter.displayType;
        this.lmsModuleService.updateSelectedTab(this.selectedTab);
      } else {
        this.historyOps.displayType = this.selectedTab.tabSearchParameter.displayType;
      }
    }
  }

  private processLocoIconInformation() {
    if (this.selectedTab.tabSearchParameter && this.selectedTab.tabSearchParameter.icon) {
      if (this.selectedTab.subTypeDetail && this.selectedTab.subTypeDetail.history && this.selectedTab.subTypeDetail.history.status && this.selectedTab.subTypeDetail.history.status === 'loaded') {
        this.locoSVG = this.selectedTab.tabSearchParameter.icon;
        this.crossCheckLocoIcon();
      } else if (this.selectedTab.subTypeDetail && this.selectedTab.subTypeDetail.history && this.selectedTab.subTypeDetail.history.status && this.selectedTab.subTypeDetail.history.status === 'refresh') {
        this.refreshLocomotiveIconInformation();
      }
    } else if (this.selectedTab && this.selectedTab.tabSearchParameter && this.selectedTab.tabSearchParameter.searchText) {
      this.refreshLocomotiveIconInformation();
    }
  }

  private refreshLocomotiveIconInformation() {
    const currentTime = (new Date()).getTime();
    if (!this.lastRequestTime || (currentTime - this.lastRequestTime) > 600) {
      this.popupService.getLocomotiveIconInformation(this.selectedTab, this.selectedTab.tabSearchParameter.searchText);
      this.iconSubscription = this.popupService.locoIconObservable.subscribe((data) => {
        if (data) {
          this.locoSVG = data.data;
          this.iconIdentified = data && data.opr && data.opr === 'success' ? true : false;
        }
        this.crossCheckLocoIcon();
      });
      this.lastRequestTime = currentTime;
    }
  }

  private crossCheckLocoIcon() {
    if (!this.locoSVG || !this.locoSVG.locomotiveIdentifier) {
      this.locoSVG = <LocoDetail>{};
      if (!this.locoSVG.locomotiveIdentifier) {
        this.locoSVG.locomotiveIdentifier = this.selectedTab.tabSearchParameter.searchText;
      }
    } else {
      this.iconIdentified = true;
    }
  }

  /**
   * this mehtod is used to catch values changes emit by child
   * value changes are changes in days/display type value
   * @param {any} event
   * @memberOf LocoHistoryHeaderComponent
   */
  historyTypeValueChangeListner(event) {
    this.historyTypeValueChange.emit(event);
  }

  ngOnDestroy() {
    if (this.iconSubscription) {
      this.iconSubscription.unsubscribe();
    }
  }

}
